var _style, _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicsValueLogoNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      dominantBaseline: "hanging"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#23B99E;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,-350)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9935,
    y1: 534.6439,
    x2: 267.1917,
    y2: 534.6439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06917D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5219,
    style: {
      stopColor: "#2CA68D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EBC9C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.3,588.9c-12.6-19.8-34.3-53.7-56.5-88.7c-28.9-45.5-70.7-68.6-124.3-68.6H4v25.5h81.5 c44.9,0,78.5,18.6,102.8,56.7c34.5,54.3,67.7,106.2,67.7,106.2l11.2,17.5L266.3,588.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.3208,
    y1: 558.0649,
    x2: 361.0746,
    y2: 558.0649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06917D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5219,
    style: {
      stopColor: "#2CA68D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EBC9C"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266.3,588.9 267.2,637.6 361.1,478.5  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,490.9c-10.4-0.4-35-0.3-54.2-0.2v-0.1H4v0.3c-0.1,0-0.1,0-0.1,0L4,503.7v131.6L3.9,648c0,0,0.1,0,0.1,0 v0.3h25.5v-0.1c7.9,0,16.8,0.1,25.2,0.1c11.9,0,23-0.1,29.1-0.3c17.6-0.6,74.9-8.2,74.9-78.5S101.3,491.6,83.7,490.9z M82.8,622.6 c-9.9,0.4-34.3,0.3-53.3,0.2V516.2c19-0.1,43.4-0.2,53.3,0.2c23,0.8,50.3,10.7,50.3,53.1C133.1,611.8,105.8,621.7,82.8,622.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicsValueLogoNav);
export default __webpack_public_path__ + "static/media/DynamicsValueLogoNav.06406c8d572e54c5164779969a5c6420.svg";
export { ForwardRef as ReactComponent };